"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineReceipts = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-namespace */
__exportStar(require("./enums_gen"), exports);
__exportStar(require("./types_gen"), exports);
const buffer_1 = require("../common/buffer");
function combineReceipts(r1, r2) {
    const anchorStr = r1.anchor instanceof Uint8Array ? buffer_1.Buffer.from(r1.anchor).toString("hex") : r1.anchor;
    const startStr = r2.start instanceof Uint8Array ? buffer_1.Buffer.from(r2.start).toString("hex") : r2.start;
    if (anchorStr !== startStr) {
        throw new Error(`Receipts cannot be combined, anchor ${anchorStr} doesn't match root merkle tree ${startStr}`);
    }
    if (!r2.anchor)
        throw new Error("Second receipt is missing the anchor");
    const result = r1.copy();
    if (!result.entries)
        result.entries = [];
    result.anchor = buffer_1.Buffer.from(r2.anchor);
    r2.entries?.forEach((e) => e && result.entries.push(e.copy()));
    return result;
}
exports.combineReceipts = combineReceipts;
//# sourceMappingURL=index.js.map